import { useRichTextEditorContext } from "@mantine/tiptap";

const LEVEL_TO_FONT_SIZE = {
    1: "16pt",
    2: "14pt",
    3: "12pt",
};

export const FontSizeSelect: React.FC = () => {
    const { editor } = useRichTextEditorContext();

    if (!editor) {
        return null;
    }

    const level = editor.getAttributes("heading").level;
    const defaultFontSize =
        editor.extensionManager.extensions.find(
            (ext) => ext.name === "fontSize"
        )?.options?.defaultFontSize;
    const value =
        editor?.getAttributes("textStyle").fontSize ||
        (level
            ? LEVEL_TO_FONT_SIZE[level as keyof typeof LEVEL_TO_FONT_SIZE]
            : defaultFontSize);

    const options = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72];

    return (
        <select
            onChange={(e) => {
                const value = e.target.value;
                if (value === "unset") {
                    editor?.chain().focus().unsetFontSize().run();
                } else {
                    editor?.chain().focus().setFontSize(value).run();
                }
            }}
            value={value || defaultFontSize}
            data-test-id="font-size-select"
            className="font-size-select text-sm xl:text-base"
        >
            {options.map((size) => (
                <option key={size} value={`${size}pt`}>
                    {size}
                </option>
            ))}
        </select>
    );
};
